var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCleanSvgrepocom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1827 6.92308V5.43046L17.0288 3.73815V1H6.875V4.14854L9.18923 4.92023L8.61046 6.65569L10.2156 7.19131L10.7944 5.455L11.1058 5.55823V6.92308C11.1058 6.92308 10.2596 11.1538 9.41346 12C8.56731 12.8462 6.875 14.5385 6.875 17.9231C6.875 19.6154 6.875 23 6.875 23H17.875C17.875 23 17.875 19.6154 17.875 16.2308C17.875 12.8462 16.1827 6.92308 16.1827 6.92308ZM8.56731 2.69231H15.3365V3.33877L14.8136 4.38462H12.9343L8.56731 2.92838V2.69231ZM12.7981 6.07692H14.4904V6.92308H12.7981V6.07692ZM16.1827 21.3077H8.56731V17.9231C8.56731 15.2399 9.84585 13.9605 10.6099 13.1965C11.4078 12.3985 12.0306 10.4625 12.4689 8.61538H14.8838C15.3585 10.4702 16.1827 14.0054 16.1827 16.2308V21.3077Z",
    fill: "#9393B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCleanSvgrepocom);
export default __webpack_public_path__ + "static/media/clean_svgrepo.com.2f59fd20dda679e950e2c2f89688e255.svg";
export { ForwardRef as ReactComponent };